import React from "react"

import FTPServer from "../../../../components/Motion_Detection/Videos/video-access-sd-card-windows"

import SEOHelmet from '../../../../components/Layout/SEOHelmet'
import Footer from "../../../../components/Layout/footer"

const seodata = {
  title: 'SD Card Access on Windows',
  description: 'The HD camera models allow you to record to the internal SD card. The easiest way to access your alarm recordings is to use our smartphone apps.',
  image: '/images/Search/MD_SearchThumb_SDCardAccess.png'
}

export default (props) => (
  <React.Fragment>
    <SEOHelmet title={seodata.title} description={seodata.description} image={seodata.image} location={props.location.pathname} />
    <h1 id="introduction" style={{ marginTop: 0 }}>
      INSTAR Kamera Tool Windows - Aufnahmen der SD Karte bequem herunterladen
    </h1>
    <FTPServer />
    <br />
    <br />
    <Footer
      previousTitle="Motion Detection"
      previousLink="/fr/Motion_Detection/"
      nextTitle="SD Card Access"
      nextLink="/fr/Motion_Detection/SD_Card_Access/" />
  </React.Fragment>
)